// Shared cinematic studio constants — the "rooms" and the production journey.
// Backdrops are darkened, scrimmed ambient photos used only as atmosphere.

export const ROOM_BACKDROPS = {
  floor:
    "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/1be5205237f1a159f2eb8a5f2297f789a04ecfff8de1a4e5ba3fa221275b6da9.jpeg",
  control:
    "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/3df8455702ff256c6461f6ec7414a58c48bde7ffd58355044e054f0552576eb6.jpeg",
  writers:
    "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/fec1233749c6618f60c026bd0c8e915c6156d9aa7d189dd9e743d7b61b0967c6.jpeg",
  stage:
    "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/4ea1c7bded85937f39bd3b429c1c4b81ad40c254cc7580aa3782376a2bc165ee.jpeg",
  theater:
    "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/4c8971b0688d9d5d195421306f9613b94768e2682a7968a8290dd6cce1fd8968.jpeg",
};

// The visible film-production journey — the spine of the whole studio.
export const PRODUCTION_JOURNEY = [
  { key: "idea", label: "Idea" },
  { key: "director", label: "Director" },
  { key: "research", label: "Research" },
  { key: "story", label: "Story" },
  { key: "script", label: "Script" },
  { key: "scenes", label: "Scenes" },
  { key: "shots", label: "Shots" },
  { key: "characters", label: "Characters" },
  { key: "visuals", label: "Visuals" },
  { key: "video", label: "Video" },
  { key: "voice", label: "Voice" },
  { key: "music", label: "Music" },
  { key: "sfx", label: "SFX" },
  { key: "continuity", label: "Continuity" },
  { key: "assembly", label: "Assembly" },
  { key: "timeline", label: "Timeline" },
  { key: "export", label: "Export" },
];

// Immersive Home hero environment.
export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/d23bfce7135cc5bfe11166579524e2181fbcedbe524658c4460ca28b4b964f7d.jpeg";

// MINIMAL primary rail — only the major destinations (per visual blueprint).
export const PRIMARY_NAV = [
  { to: "/", label: "Home", icon: "home", end: true },
  { to: "/projects", label: "Projects", icon: "projects" },
  { to: "/create", label: "Create", icon: "create" },
  { to: "/production", label: "Studio", icon: "studio" },
  { to: "/assets", label: "Assets", icon: "assets" },
  { to: "/export-center", label: "Export", icon: "export" },
];

// Contextual production rooms — reached from the top-bar Rooms launcher,
// Home, Projects, a Project and the production workflow (NOT permanent rail items).
export const STUDIO_ROOMS = [
  { to: "/cinematic-planner", label: "Cinematic Planner", desc: "Storyboard · scenes · shots", icon: "planner" },
  { to: "/video-engine", label: "Video Engine", desc: "Virtual production stage", icon: "video" },
  { to: "/voice-studio", label: "Voice Studio", desc: "Recording booth", icon: "voice" },
  { to: "/sound-library", label: "Sound Library", desc: "Sound design room", icon: "sound" },
  { to: "/brand-studio", label: "Brand Studio", desc: "Art department", icon: "brand" },
  { to: "/templates", label: "Templates", desc: "Production library", icon: "templates" },
  { to: "/prompts", label: "Prompts", desc: "Director's notebook", icon: "prompts" },
  { to: "/editor", label: "Editor", desc: "Editing suite", icon: "editor" },
  { to: "/publishing", label: "Publishing", desc: "Distribution room", icon: "publishing" },
  { to: "/storage", label: "Storage", desc: "Studio archive", icon: "storage" },
  { to: "/activity", label: "Activity", desc: "Production log", icon: "activity" },
];

// System / account destinations (Help is NOT here — it lives in Nova + account).
export const SYSTEM_ROOMS = [
  { to: "/billing", label: "Membership", desc: "Plans · credits · billing", icon: "billing" },
];

// Per-room background atmosphere — a UNIQUE, high-fidelity futuristic scene per
// route (regenerated fresh at max quality; nothing repeated). Kept versioned here
// so the whole studio shares one visual language and pages read distinctly.
const IMG = "https://static.prod-images.emergentagent.com/jobs/8d49184e-2b2a-421f-8a51-d7259043748a/images/";
export const ROOM_ATMOSPHERE = {
  "/":                 { image: IMG + "d23bfce7135cc5bfe11166579524e2181fbcedbe524658c4460ca28b4b964f7d.jpeg", tint: "rgba(91,77,255,0.12)" },
  "/create":           { image: IMG + "ee7639091b34b7827334b3294b58ee47c7449448d9b7d739d2626cf9605c19f5.jpeg", tint: "rgba(91,77,255,0.12)" },
  "/projects":         { image: IMG + "04b89be7fdd38440af913a24a08509f9f915a40da060c0ead89c71e7932b734d.jpeg", tint: "rgba(124,112,255,0.12)" },
  "/production":       { image: IMG + "5c8858fc2bde81d548cf98a365d9cfb81cb29eead7fe0fc074a38d2cdd810d01.jpeg", tint: "rgba(91,77,255,0.12)" },
  "/cinematic-planner":{ image: IMG + "03e3aa4e9a61f1c44bc799a72cf9a790f4dcbd877b053e7a7b8c37717d4880b5.jpeg", tint: "rgba(120,90,255,0.12)" },
  "/video-engine":     { image: IMG + "704dd76e77881501220646051729b239209df7d80ebe1ef5aec3a232d1edf73d.jpeg", tint: "rgba(80,120,255,0.12)" },
  "/voice-studio":     { image: IMG + "2233e3d313d376f55325b4f2f65514a429794acebcc8fc826785996e75ee9305.jpeg", tint: "rgba(150,90,255,0.12)" },
  "/sound-library":    { image: IMG + "ca622a2dc2f955bc09e1475f8bd02aa05bd7686d7035ae6cef530f875cec7e36.jpeg", tint: "rgba(90,110,255,0.12)" },
  "/brand-studio":     { image: IMG + "d101aacd4cb91ce6fbb05c49dc974c276347555ca78f204ca8c59ca536b6131f.jpeg", tint: "rgba(255,120,180,0.10)" },
  "/assets":           { image: IMG + "2181c0431c08a9eddb1903e2fa4c280abc91f1270ff6c4d8e17c5529c67f6014.jpeg", tint: "rgba(91,77,255,0.12)" },
  "/storage":          { image: IMG + "ecef3ba13143cbdca29cc1c859094d9b77bb857222eb4835c6c0f002dc8cbac2.jpeg", tint: "rgba(80,90,140,0.10)" },
  "/templates":        { image: IMG + "fcd3e028459eaa7d535ed64c13e5785bdd0d0fe99f66094c6d9d1252525a49c5.jpeg", tint: "rgba(124,112,255,0.12)" },
  "/prompts":          { image: IMG + "b8183df5a99d5b51282f0124eab7d87c8aea34e7f2266c930d81f6af65d011a2.jpeg", tint: "rgba(255,179,0,0.08)" },
  "/editor":           { image: IMG + "601044f5605e1fd8f3932946b9e44241a843e7d1fb3fb01acd5fa203ed0aca17.jpeg", tint: "rgba(70,90,140,0.12)" },
  "/export-center":    { image: IMG + "889b76e21d6873d09deec981564f74c7105cf6b303a1851d94ba98211c889211.jpeg", tint: "rgba(91,77,255,0.12)" },
  "/publishing":       { image: IMG + "12f614861f011e2ce96b9c3e429223763e28e0d6edea5ed48872c5b16dcd2cfa.jpeg", tint: "rgba(255,120,180,0.10)" },
  "/activity":         { image: IMG + "bdc51adce70570b9578f1276657e4e9cc62bc95ea6f7f1b1d00f6eb08c693ff7.jpeg", tint: "rgba(80,90,140,0.10)" },
  "/settings":         { image: IMG + "d514b6211538e43b7ae734544db915b666a3e9c2924e636d90b1f08d4dab67d0.jpeg", tint: "rgba(80,90,140,0.10)" },
  "/billing":          { image: IMG + "2120584112dea22e83572f73f5caa56057d54fd06760db06ca07c19a62e2e410.jpeg", tint: "rgba(255,179,0,0.10)" },
  "/help":             { image: IMG + "a644bec9eb29663e6cc1aa34b0a5fd0f6e93368da7edd45173bec3324bec210a.jpeg", tint: "rgba(91,77,255,0.10)" },
  "/admin":            { image: IMG + "5c8858fc2bde81d548cf98a365d9cfb81cb29eead7fe0fc074a38d2cdd810d01.jpeg", tint: "rgba(91,77,255,0.12)" },
};

export function atmosphereFor(pathname) {
  if (pathname.startsWith("/projects/")) return { image: IMG + "5338d9dfdd3c25e9a50d70f2b3e1241814741c7406cf43d133f0d74e29c740a7.jpeg", tint: "rgba(91,77,255,0.12)" };
  return ROOM_ATMOSPHERE[pathname] || ROOM_ATMOSPHERE["/"];
}
